var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'dd-m-loading-box' + (_vm.type ? _vm.type : '')},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dd-m-loading"},[_c('i',{staticClass:"dd-m-icon icon-perfume"})])}]
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cf5a10c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/site/js/components/loading.vue
// module id = 40
// module chunks = 0 1 3 4 5 6 7 8 9 12 13 14